import React from 'react';
import PublicNavBar from './PublicNavBar';
import PublicFooter from './PublicFooter';
import '../styles/PublicLayout.css';

export default function PublicLayout({ children }) {
  return (
    <div className="public-layout">
      <PublicNavBar />
      <main className="public-main">
        {children}
      </main>
      <PublicFooter />
    </div>
  );
} 